import React from "react";
import { Link } from "react-router-dom";

function AuthHeader() {
    return (
        <div className="flex justify-between items-center w-full h-16 py-3">
            <Link to={"/"} className="font-semibold h-full hover:bg-surface-raised rounded-lg">
                <img className="h-full object-cover" src="./img/brand-logo/logo.png" alt="logo" />
            </Link>
        </div>
    );
}

export default AuthHeader;
